import useBackgroundService from './useBackgroundService'

export default useBackgroundService
